import React, { FC } from 'react'
import styles from './CuratedDeals.module.scss'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'

const Banner: FC<ListProps> = ({ promoCode }) => {
  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        Use code <span>{promoCode}</span> at checkout for exclusive pricing on this week’s picks.*
      </p>
    </div>
  )
}

export default ListConnector(Banner)
